const initialState = {}

const appendedRegions = (state, data) => {
  return [ ...state.regions, data ]
}

const updatedRegions = (state, data) => {
  const regionIndex = state.regions.findIndex((region) => { return region.id == data.id })
  if (regionIndex == -1) return state.regions

  return [
    ...state.regions.slice(0, regionIndex), 
    data,
    ...state.regions.slice(regionIndex + 1, state.regions.length)
  ]
}

const releasedRegions = (state, data) => {
  const regionIndex = state.regions.findIndex((region) => { return region.id == data.id })
  if (regionIndex == -1) return state.regions

  return [
    ...state.regions.slice(0, regionIndex), 
    ...state.regions.slice(regionIndex + 1, state.regions.length)
  ]
}

const regions = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'REGIONS.INIT':
      return {...state, ...payload}
    case 'REGIONS.CREATE':
      return {...state, regions: appendedRegions(state, payload)}
    case 'REGIONS.UPDATE':
      return {...state, regions: updatedRegions(state, payload)}
    case 'REGIONS.DELETE':
      return {...state, regions: releasedRegions(state, payload)}
    default:
      return state
  }
}

export default regions
